import React, { useState, useEffect } from "react";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Col } from "reactstrap";
import axios from "axios";

const LinkCandidatesPopup = ({
  setSelectedScheduleCandidates,
  setFormErrors,
  formErrors,
}) => {
  const [typeInterviewcondi, settypeInterviewcondi] = useState([]);
  const [selectedCandidates, setSelectedCandidates] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [selectedCandidateNames, setSelectedCandidateNames] = useState("");
  const [candidateDetailsVisible, setCandidateDetailsVisible] = useState(false);

  const [totalRecords, setTotalRecords] = useState(0);

  // Pagination state
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: 10,
    page: 0,
  });

  // Fetch candidates from API
  const getAllActive = async () => {
    try {
      const page = lazyParams.page + 1;
      const response = await axios.get(`/api/v1/candidates/?page=${page}&status=Active`);
      if (response.data) {
        const transformedData = response.data.results.map((cond) => ({
          id: cond.candidate_id,
          name: cond.first_name,
          designation: cond.designation || "N/A",
          job_title: cond.job_title,
        }));
        settypeInterviewcondi(transformedData);
        setTotalRecords(response.data.count);
      } else {
        settypeInterviewcondi([]);
      }
    } catch (error) {
      console.log("Failed to fetch candidates", error);
      settypeInterviewcondi([]);
    }
  };

  // Fetch on dialog open or pagination/search change
  useEffect(() => {
    if (candidateDetailsVisible) {
      getAllActive();
    }
  }, [lazyParams, candidateDetailsVisible]);

  const handleIconClick = () => {
    setCandidateDetailsVisible(true);
  };

  const handleSave = () => {
    const selectedNames = selectedCandidates
      .map((candidate) => candidate.name)
      .join(", ");
    const selectedIds = selectedCandidates.map((candidate) => candidate.id);
    setSelectedCandidateNames(selectedNames);
    setSelectedScheduleCandidates(selectedIds);
    // Clear error for selectedScheduleContacts when contacts are selected
    if (selectedIds.length > 0) {
      setFormErrors((prev) => ({ ...prev, selectedScheduleCandidates: "" }));
    }
    setCandidateDetailsVisible(false);
  };

  const handleRefresh = () => {
    setSearchText("");
    setSelectedCandidates([]);
    setLazyParams({ ...lazyParams, page: 0, first: 0 });
    getAllActive();
  };

  const filteredCandidates = typeInterviewcondi.filter((candidate) => {
    console.log(candidate);

    const name = candidate?.name?.toLowerCase() || "";
    const jobTitle = candidate?.job_title?.toLowerCase() || "";
    const idStr = candidate?.id?.toString() || "";

    return (
      name.includes(searchText.toLowerCase()) ||
      jobTitle.includes(searchText.toLowerCase()) ||
      idStr.includes(searchText)
    );
  });
  return (
    <Col lg={6}>
      <div className="field">
        <label htmlFor="candidateDetail" className="block mb-0">
          Link Candidates
        </label>
        <div
          className="d-flex align-items-center"
          style={{ position: "relative" }}
        >
          <InputText
            id="candidateDetail"
            value={selectedCandidateNames}
            // onChange={(e) => {setSelectedCandidateNames(e.target.value)}}
            placeholder="Select Candidates"
            className="w-full"
            style={{ paddingRight: "2rem" }}
          />
          <i
            className="pi pi-chevron-down"
            onClick={handleIconClick}
            style={{
              position: "absolute",
              right: "10px",
              top: "50%",
              transform: "translateY(-50%)",
              cursor: "pointer",
            }}
          ></i>
        </div>
        {formErrors.selectedScheduleCandidates && (
          <small className="p-error">
            {formErrors.selectedScheduleCandidates}
          </small>
        )}

        <Dialog
          header="Link Candidates"
          visible={candidateDetailsVisible}
          onHide={() => setCandidateDetailsVisible(false)}
          style={{ width: "40vw" }}
          breakpoints={{ "960px": "75vw", "641px": "100vw" }}
          className="cand-details"
        >
          {/* Search Bar */}
          <Col lg={6}>
            <div className="p-inputgroup mb-3" style={{ position: "relative" }}>
              <InputText
                placeholder="Search Candidates"
                value={searchText}
                onInput={(e) => setSearchText(e.target.value)}
                style={{ paddingRight: "2rem" }}
              />
              <i
                className="pi pi-search"
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "49%",
                  transform: "translateY(-50%)",
                }}
              ></i>
            </div>
          </Col>

          {/* DataTable */}
          <DataTable
            value={filteredCandidates}
            lazy
            paginator
            totalRecords={totalRecords}
            first={lazyParams.first}
            rows={lazyParams.rows}
            onPage={(e) => setLazyParams(e)}
            selection={selectedCandidates}
            onSelectionChange={(e) => setSelectedCandidates(e.value)}
            dataKey="id"
            rowsPerPageOptions={10}
            size="small"
          >
            <Column selectionMode="multiple" style={{ width: "3em" }} />
            <Column field="name" header="Candidate Name" />
            <Column field="designation" header="Designation" />
            <Column field="job_title" header="Job Title" />
          </DataTable>

          {/* Actions */}
          <div className="d-flex mt-3">
            <button
              type="button"
              className="btn btn-primary me-2 btn-main"
              onClick={handleSave}
            >
              Save
            </button>
            <button
              type="button"
              className="btn btn-primary btn-main"
              onClick={handleRefresh}
            >
              Refresh
            </button>
          </div>
        </Dialog>
      </div>
    </Col>
  );
};

export default LinkCandidatesPopup;
